<div class="GlobalLayout GlobalLayout--twoColumn">
  <main id="MainContent" role="main" tabindex="-1" class="Main" role="main">
    <header class="Main-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap">
        <h1 class="Main-heading">Resources</h1>
        <div class="Actions justify-content-end">
          <div class="Actions-item Actions-item--large">
            <span class="bento-search">
              <label for="global-search" class="sr-only">Search all resources</label>
              <input type="text" id="global-search" name="global-search" class="form-control"
                [(ngModel)]="globalSearchText" bentoReset placeholder="Search all resources"
                (keydown.enter)="searchAllResources()" [disabled]="isLoading" />
              <button type="button" class="btn btn-primary" (click)="searchAllResources()" [disabled]="isLoading">
                <span class="btn-text">Search</span>
              </button>
            </span>
          </div>
        </div>

        <!-- <div class="Actions global-search d-flex align-items-center mb-2">
            <label for="global-search" class="sr-only">Search all resources</label>
            <input
              type="text"
              id="global-search"
              name="global-search"
              type="text"
              class="form-control mr-2"
              placeholder="Search all resources"
              [(ngModel)]="globalSearchText"
               bentoReset 
              (keydown.enter)="searchAllResources()"
            /><button class="btn btn-primary" (click)="searchAllResources()">Search</button>
          </div> -->
      </div>

    </header>
    <div class="search-result-container-global">

      <h2 *ngIf="showGlobalResults" class="h5">{{ globalResultAnnouncement }}</h2>
      <!-- Accessibility live region -->
      <div aria-live="polite" aria-atomic="true" class="sr-only">
        {{ globalResultAnnouncement }}
      </div>
      <div #globalResults *ngIf="showGlobalResults" class="search-result-container alert alert-light mt-3" 
        [ngClass]="{'nosearchResults': globalSearchResults.length === 0}" role="region"
        aria-label="Search results">
        <button type="button" class="close close-global-results" aria-label="Close search results" (click)="closeGlobalSearch()" cdkFocusClasses>
          <i class="bento-icon-close-x" aria-hidden="true"></i>
        </button>
        <div *ngIf="globalSearchResults.length > 0; else noGlobalResults">
          <ul class="bento-list">
            <ng-container *ngFor="let group of groupedGlobalResults | keyvalue">
              <li class="bento-list-item">
                <h3 class="mb-2">{{ group.key }}</h3>
                <ul class="bento-list mb-3">
                  <ng-container *ngIf="!expandedGroups[group.key]">
                    <li class="bento-list-item" *ngFor="let file of group.value.slice(0, 20)">
                      <a [routerLink]="['.']" (click)="downloadResourceFile(file.link, file.name, file.extension)"
                        [attr.aria-label]="group.key + ', ' + (file.name.split('.').slice(0, -1).join('.'))">
                        {{ file.name.split('.').slice(0, -1).join('.') }}
                      </a>
                      <span>&nbsp; ({{ file.extension?.toUpperCase() || 'PDF' }})</span>
                    </li>
                    <li class="bento-list-item" *ngIf="group.value.length > 20">
                      <a href="#" (click)="expandedGroups[group.key] = true; $event.preventDefault()">
                        Show {{ group.value.length - 20 }} more results
                      </a>
                    </li>
                  </ng-container>

                  <ng-container *ngIf="expandedGroups[group.key]">
                    <li class="bento-list-item" *ngFor="let file of group.value">
                      <a [routerLink]="['.']" (click)="downloadResourceFile(file.link, file.name, file.extension)">
                        {{ file.name.split('.').slice(0, -1).join('.') }}
                      </a>
                      <span>&nbsp; ({{ file.extension?.toUpperCase() || 'PDF' }})</span>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ul>


        </div>
        <ng-template #noGlobalResults>
          <p>No results found across all categories.</p>
        </ng-template>
      </div>
    </div>
    <div class="Main-body">
      <div class="GlobalLayout-group">
        <div class="GlobalLayout-item GlobalLayout-item--small">
          <bento-side-nav class="NavSide" aria-label="Resources" [collapsible]="true" [items]="items"></bento-side-nav>
        </div>
        <div class="GlobalLayout-item GlobalLayout-item--large">
          <ng-container *ngIf="items[0].data.isVisible && resourceContent">
            <h2>Reference documents</h2>
            <ul class="bento-list" *ngIf="resourceContent.reference">
              <li class="bento-list-item mb-3" *ngFor="let content of resourceContent.reference">
                <a [routerLink]="['.']" (click)="downloadResourceFile(content.link, content.name, content.extension)">
                  {{ content.name.split('.').slice(0, -1).join('.') }}
                </a>
                <span> ({{ content.extension | uppercase }})</span>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="items[1].data.isVisible && resourceContent">
            <h2>User guide</h2>
            <ul class="bento-list" *ngIf="resourceContent.userGuide">
              <li class="bento-list-item mb-3" *ngFor="let content of resourceContent.userGuide">
                <a [routerLink]="['.']" (click)="downloadResourceFile(content.link, content.name, content.extension)">
                  {{ content.name.split('.').slice(0, -1).join('.') }}
                </a>
                <span>&nbsp;({{ content.extension | uppercase }})</span>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="items[2].data.isVisible && resourceContent">
            <div class="Actions justify-content-end">
              <div class="Actions-item Actions-item--large">
                <span class="bento-search">
                  <label for="Legal-industry-update" class="sr-only">Legal industry update</label>
                  <input type="text" name="Legal industry update" id="Legal-industry-update" class="form-control"
                    [(ngModel)]="searchText" bentoReset placeholder="Search within Legal industry update"
                    (keydown.enter)="searchResources()" (ngModelChange)="searchText = $event; searchResources()" />
                  <!-- <button type="button" class="btn btn-primary" (click)="searchResources()">
                    <span class="btn-text">Search</span>
                  </button> -->
                </span>
              </div>
            </div>
            <h2>Legal industry update</h2>
            <address>
              If you are looking for legal industry updates beyond 2019 contact a Financial Insights
              <a href="mailto:financialinsights@thomsonreuters.com">representive</a>.
            </address>
            <div *ngIf="noResultsFound" class="alert alert-info" role="alert">
              <p>No results found. Try searching for a different term.</p>
            </div>
            <ng-container *ngIf="resourceContent.liu">
              <div aria-live="polite" aria-atomic="true" class="sr-only">
                {{ resultAnnouncement }}
              </div>
              <section *ngFor="let content of resourceContent.liu">
                <ng-container *ngFor="let files of content.files | keyvalue">
                  <ng-container *ngIf="files.value.length > 0">
                    <div class="d-inline-flex">
                      <h3>{{ content.year }} {{ files.key }}</h3>
                      <span>&nbsp;- (PDF)</span>
                    </div>
                    <ul class="bento-list mb-3">
                      <li class="bento-list-item" *ngFor="let file of files.value">
                        <a [routerLink]="['.']" (click)="downloadResourceFile(file.link, file.name, file.extension)">
                          {{ file.name.split('.').slice(0, -1).join('.') }}
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                </ng-container>
              </section>
            </ng-container>
          </ng-container>
          <ng-container *ngFor="let item of items[3].items">
            <ng-container *ngIf="item.data.isVisible && resourceContent && item.label ==selectedCountry">
              <div class="Actions justify-content-end">
                <div class="Actions-item Actions-item--large">
                  <span class="bento-search">
                    <label for="Client-Reports" class="sr-only">Client Reports</label>
                    <input type="text" name="Client Reports" id="Client-Reports" class="form-control"
                      [(ngModel)]="searchText" bentoReset placeholder=" Search within Client reports - {{ selectedCountry }}"
                      (keydown.enter)="searchResources()" (ngModelChange)="searchText = $event; searchResources()" />
                    
                  </span>
                </div>
              </div>
              <h2>Client reports - {{ selectedCountry }}</h2>
              <address>
                If you are looking for client reports beyond 2019 contact a Financial Insights
                <a href="mailto:financialinsights@thomsonreuters.com">representive</a>.
              </address>
              <div *ngIf="noResultsFound" class="alert alert-info" role="alert">
                <p>No results found. Try searching for a different term.</p>
              </div>
              <ng-container *ngIf="resourceContent.clientReport">
                <div aria-live="polite" aria-atomic="true" class="sr-only">
                  {{ resultAnnouncement }}
                </div>
                <section *ngFor="let content of resourceContent.clientReport">
                  <ng-container *ngIf="content.country == selectedCountry">
                    <!--  Story 829572 - Add thumbnails for client reports -->
                    <ng-container *ngIf="content.firstThreeList.length > 0">
                      <ul class="bento-list list-view">
                        <li class="bento-list-item"
                          *ngFor="let files of content.firstThreeList | keyvalue : asIsOrder;">
                          <a [routerLink]="['.']" [bentoBusyLoader]="files.value.imageLoad"
                            (click)="downloadResourceFile(files.value.link, files.value.name, files.value.extension)">
                            <img [src]="files.value.image" alt="{{ files.value.name }}"
                              (load)="onImageLoad(files.value)" />
                            {{ files.value.name.split('.').slice(0, -1).join('.') }}
                          </a>
                        </li>
                      </ul>
                    </ng-container>
                    <!--  Story 829572 - Add thumbnails for client reports -->
                    <ng-container *ngFor="let files of content.files | keyvalue : asIsOrder;">
                      <div *ngIf="files.value.length > 0">
                        <div class="d-inline-flex">
                          <h3>{{ files.key }} {{ content.country }}</h3>
                          <span>&nbsp;- (PDF)</span>
                        </div>
                        <ul class="bento-list mb-3">
                          <li class="bento-list-item" *ngFor="let file of files.value">
                            <a [routerLink]="['.']"
                              (click)="downloadResourceFile(file.link, file.name, file.extension)">
                              {{ file.name.split('.').slice(0, -1).join('.') }}
                            </a>
                          </li>
                        </ul>
                      </div>
                    </ng-container>
                  </ng-container>
                </section>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="items[4].data.isVisible && resourceContent">
            <div class="Actions justify-content-end">
              <div class="Actions-item Actions-item--large">
                <span class="bento-search">
                  <label for="Thought-leadership-reports" class="sr-only">Thought leadership reports</label>
                  <input bentoReset type="text" name="Thought leadership reports" id="Thought-leadership-reports"
                    class="form-control" [(ngModel)]="searchText" bentoReset
                    placeholder="Search within Thought leadership reports" (keydown.enter)="searchResources()"
                    (ngModelChange)="searchText = $event; searchResources()" />
                 
                </span>
              </div>
            </div>
            <h2>Thought leadership reports</h2>
            <address>
              If you are looking for thought leadership reports beyond 2019 contact a Financial Insights
              <a href="mailto:financialinsights@thomsonreuters.com">representive</a>.
            </address>
            <div *ngIf="noResultsFound" class="alert alert-info" role="alert">
              <p>No results found. Try searching for a different term.</p>
            </div>
            <ng-container *ngIf="resourceContent.thoughtLeadershipReports">
              <div aria-live="polite" aria-atomic="true" class="sr-only">
                {{ resultAnnouncement }}
              </div>
              <section *ngFor="let content of resourceContent.thoughtLeadershipReports">
                <ng-container *ngFor="let files of content.files | keyvalue">
                  <ng-container *ngIf="files.value.length > 0">
                    <div class="d-inline-flex">
                      <h3>{{ content.year }}</h3>
                    </div>
                    <ul class="bento-list mb-3">
                      <li class="bento-list-item" *ngFor="let file of files.value">
                        <a [routerLink]="['.']" (click)="downloadResourceFile(file.link, file.name, file.extension)">
                          {{ file.name.split('.').slice(0, -1).join('.') }}
                        </a>
                        <span>&nbsp; (PDF)</span>
                      </li>
                    </ul>
                  </ng-container>
                </ng-container>
              </section>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="items[5].data.isVisible && resourceContent">
            <div class="Actions justify-content-end">
              <div class="Actions-item Actions-item--large">
                <span class="bento-search">
                  <label for="Law-firm-financial-index" class="sr-only">Law firm financial index</label>
                  <input type="text" name="Law firm financial index" id="Law-firm-financial-index" class="form-control"
                    [(ngModel)]="searchText" bentoReset placeholder="Search within Law firm financial index"
                    (keydown.enter)="searchResources()" (ngModelChange)="searchText = $event; searchResources()" />
                  
                </span>
              </div>
            </div>
            <h2>Law firm financial index</h2>
            <address>
              If you are looking for law firm financial index beyond 2019 contact a Financial Insights
              <a href="mailto:financialinsights@thomsonreuters.com">representive</a>.
            </address>
            <div *ngIf="noResultsFound" class="alert alert-info" role="alert">
              <p>No results found. Try searching for a different term.</p>
            </div>
            <ng-container *ngIf="resourceContent.lawFirmFinancialIndex">
              <div aria-live="polite" aria-atomic="true" class="sr-only">
                {{ resultAnnouncement }}
              </div>
              <section *ngFor="let content of resourceContent.lawFirmFinancialIndex">
                <ng-container *ngFor="let files of content.files | keyvalue">
                  <ng-container *ngIf="files.value.length > 0">
                    <div class="d-inline-flex">
                      <h3>
                        {{ content.year }}
                        <ng-container *ngIf="yearForPeerMonitor.includes(content.year)">(Peer Monitor Index)
                        </ng-container>
                      </h3>
                    </div>
                    <ul class="bento-list mb-3">
                      <li class="bento-list-item" *ngFor="let file of files.value">
                        <a [routerLink]="['.']" (click)="downloadResourceFile(file.link, file.name, file.extension)">
                          {{ file.name.split('.').slice(0, -1).join('.') }}
                        </a>
                        <span>&nbsp; (PDF)</span>
                      </li>
                    </ul>
                  </ng-container>
                </ng-container>
              </section>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </main>
</div>